import { PropsWithChildren } from "react";
import { Grid, useTheme } from "@mui/material";

type Props = {
  isSigned?: boolean;
};

const Error = ({ children, isSigned }: PropsWithChildren<Props>) => {
  const theme: any = useTheme();

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
      sx={{
        backgroundColor: theme.palette.grey[900],
        minHeight: isSigned ? "100%" : "100vh",
      }}
    >
      {children}
    </Grid>
  );
};

export default Error;
